import * as Yup from "yup";
import { isValidPhone } from "./ValidationUtil";
import { ALERTAS_GENERICAS } from "./AlertasGenericas";

export const validationSchemaRequired = Yup.object().shape({
  requiredField: Yup.string().required(ALERTAS_GENERICAS.CAMPO_REQUERIDO),
});

export const validationSchemaEmail = Yup.object().shape({
  emailField: Yup.string()
    .email(ALERTAS_GENERICAS.CORREO_INVALIDO)
});

export const validationSchemaPhone = Yup.object().shape({
    phoneField: Yup.string().test(
    "phone",
    ALERTAS_GENERICAS.TELEFONO_INVALIDO,
    (value) => isValidPhone(value)
  ),
});

export const validationSchemaCustom = (callBack, errorMessage) =>
  Yup.object().shape({
    customField: Yup.string().test("custom", errorMessage, (value) =>
      callBack(value)
    ),
  });

export const validationSchemaMedicoPrescriptor = Yup.object().shape({
  medicoPrescriptorField: Yup.string()
    .required(ALERTAS_GENERICAS.MEDICO_PRESCRIPTOR_REQUERIDO)
    .test(
      "minLength",
      ALERTAS_GENERICAS.MEDICO_PRESCRIPTOR_MIN_CARACTERES,
      (value) => !value || value.trim().length >= 5
    )
    .test(
      "onlyLetters",
      ALERTAS_GENERICAS.MEDICO_PRESCRIPTOR_SOLO_LETRAS,
      (value) => {
        if (!value || typeof value !== "string") {
          return true;
        }
        const trimmedValue = value.trim();
        if (trimmedValue.length < 5) {
          return true;
        }
        const patronSoloLetrasEspacios = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
        return patronSoloLetrasEspacios.test(trimmedValue);
      }
    ),
});